<section class="conversation">
  <ng-content select="[header]"></ng-content>
  <div class="conversation__messages" #messagesContainer="autoScroll" appAutoScroll>
    @if (isLoading) {
      <div class="spinner-container">
        <app-slr-spinner [isLoading]="true"></app-slr-spinner>
      </div>
    }

    @if (!conversation?.messages?.length && !isLoading && shouldShowWelcomeMessage) {
      <app-welcome-message
        [agent]="agent"
      ></app-welcome-message>
    }
    <app-conversation-message></app-conversation-message>
  </div>
  @if (inputDisabledReason) {
    <div class="conversation__input-disabled" role="status">
      <span class="material-icons" translate="no" aria-hidden="true">info</span>
      <span>{{ inputDisabledReason }}</span>
    </div>
  } @else {
    <div
      class="conversation__input"
      [class.conversation__input--with-summary]="isMultiSummaryVisible"
      >
      <app-status-center
        class="conversation__status-center"
        [referenceProgress]="referenceProgressAboveInput"
        [isWriting]="isWriting"
      ></app-status-center>

      <!-- Use dynamic input if uiConfiguration has input fields AND conversation hasn't started -->
      @if (uiConfiguration && uiConfiguration.inputFields && uiConfiguration.inputFields.length > 0 && !conversation?.messages?.length) {
        <app-conversation-input-dynamic
        [options]="{
          allowAttachFile: allowAttachFile,
          isExtended: conversationInputExtended,
          promptHints: agent?.promptHints ?? [],
          filterButton: filtersButtonEnabled
        }"
          [bot]="agent"
          [isWriting]="isWriting"
          [conversationStarted]="!!conversation?.messages?.length"
          [uiConfiguration]="uiConfiguration"
          (writingAbort)="agentConversationService.abortRequests()"
          (messageSubmitted)="onMessageSubmit($event)"
        ></app-conversation-input-dynamic>
      }

      <!-- Use regular input if no uiConfiguration OR conversation has started -->
      @if (!uiConfiguration || !uiConfiguration.inputFields || uiConfiguration.inputFields.length === 0 || !!conversation?.messages?.length) {
        <app-conversation-input
        [options]="{
          allowAttachFile: allowAttachFile,
          isExtended: conversationInputExtended,
          promptHints: agent?.promptHints ?? [],
          filterButton: filtersButtonEnabled
        }"
          [bot]="agent"
          [isWriting]="isWriting"
          [conversationStarted]="!!conversation?.messages?.length"
          [uiConfiguration]="uiConfiguration"
          [message]="initialMessage"
          (writingAbort)="agentConversationService.abortRequests()"
          (messageSubmitted)="onMessageSubmit($event)"
        ></app-conversation-input>
      }

      <ng-content select="[belowInput]"></ng-content>
    </div>
  }
</section>
